/**
 * Hook to lazy-load a catalog by ID using TanStack Query.
 */

import { useQuery } from '@tanstack/react-query';

import type { ICatalog } from '@/workflows/vascular/common/catalog';
import { loadCatalog } from '@/workflows/vascular/evar/strategy';

const catalogKeys = {
    all: ['catalogs'] as const,
    detail: (id: string) => ['catalogs', id] as const,
};

export function useCatalog(catalogId: string | null) {
    const {
        data: catalog = null,
        isLoading: loading,
        error,
    } = useQuery({
        queryKey: catalogKeys.detail(catalogId!),
        queryFn: () => loadCatalog(catalogId!),
        enabled: !!catalogId,
        staleTime: Infinity,
        gcTime: Infinity,
    });

    return {
        catalog: catalog as ICatalog | null,
        loading,
        error: error ? (error instanceof Error ? error.message : String(error)) : null,
    };
}
